/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { Checkbox } from '@atlaskit/checkbox';
import { jsx } from '@atlaskit/css';
import { Label, RequiredAsterisk } from '@atlaskit/form';
import { Stack } from '@atlaskit/primitives/compiled';

type Props = {
	label: string;
	name: string;
	isRequired: boolean;
	options: { label: string; value: string }[];
};

export const CheckboxGroupInput = ({ label, name, isRequired, options }: Props): JSX.Element => (
	<Stack space="space.050">
		<Label htmlFor={name}>
			{label}
			{isRequired && <RequiredAsterisk />}
		</Label>
		<Stack space="space.050">
			{options.map((option) => (
				<Checkbox
					key={option.value}
					name={name}
					value={option.value}
					label={option.label}
					isRequired={isRequired}
				/>
			))}
		</Stack>
	</Stack>
);
